/* eslint-disable react/jsx-key */

import {useEffect, useState} from 'react';

import styles from '@/components/css/AnimatedCheck.module.css';

export default function AnimatedCheck() {
  const [frame, setFrame] = useState(-1);

  useEffect(() => {
    const raf = requestAnimationFrame(() => {
      if (frame < frames.length - 1) {
        setFrame(frame + 1);
      } else {
        // Stop at the end.
        cancelAnimationFrame(raf);
      }
    });
    return () => cancelAnimationFrame(raf);
  }, [frame]);

  return <div className={styles.container}>{frames[frame]}</div>;
}

const frames = [
  <svg
    width="114"
    height="114"
    viewBox="0 0 114 114"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M57 3C58.5584 3 60.116 3.06746 61.6685 3.20218"
      stroke="currentColor"
      strokeWidth="6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
  <svg
    width="114"
    height="114"
    viewBox="0 0 114 114"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M57 3C61.7191 3 66.4179 3.6186 70.9762 4.84"
      stroke="currentColor"
      strokeWidth="6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
  <svg
    width="114"
    height="114"
    viewBox="0 0 114 114"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M57 3C66.479 3 75.791 5.49514 84 10.2346"
      stroke="currentColor"
      strokeWidth="6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
  <svg
    width="114"
    height="114"
    viewBox="0 0 114 114"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M57 3C71.3217 3 85.0568 8.68927 95.1838 18.8162"
      stroke="currentColor"
      strokeWidth="6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
  <svg
    width="114"
    height="114"
    viewBox="0 0 114 114"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M57 3C66.479 3 75.791 5.49514 84 10.2346C92.209 14.9741 99.0259 21.791 103.765 30"
      stroke="currentColor"
      strokeWidth="6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
  <svg
    width="114"
    height="114"
    viewBox="0 0 114 114"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M57 3C68.8873 3 80.4423 6.92242 89.8731 14.1589C99.3039 21.3954 106.083 31.5416 109.16 43.0238"
      stroke="currentColor"
      strokeWidth="6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
  <svg
    width="114"
    height="114"
    viewBox="0 0 114 114"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M57 3C64.0914 3 71.1133 4.39675 77.6649 7.11051C84.2165 9.82426 90.1694 13.8019 95.1838 18.8162C100.198 23.8306 104.176 29.7835 106.889 36.3351C109.603 42.8867 111 49.9086 111 57"
      stroke="currentColor"
      strokeWidth="6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
  <svg
    width="114"
    height="114"
    viewBox="0 0 114 114"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M57 3C65.2829 3 73.4549 4.90542 80.8836 8.56887C88.3123 12.2323 94.7988 17.5556 99.8411 24.1269C104.883 30.6982 108.346 38.3413 109.962 46.4651C111.578 54.5889 111.304 62.9755 109.16 70.9762"
      stroke="currentColor"
      strokeWidth="6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
  <svg
    width="114"
    height="114"
    viewBox="0 0 114 114"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M57 3C66.479 3 75.791 5.49514 84 10.2346C92.209 14.9741 99.0259 21.791 103.765 30C108.505 38.209 111 47.521 111 57C111 66.479 108.505 75.791 103.765 84"
      stroke="currentColor"
      strokeWidth="6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
  <svg
    width="114"
    height="114"
    viewBox="0 0 114 114"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M57 3C67.6802 3 78.1205 6.16704 87.0008 12.1006C95.881 18.0342 102.802 26.4679 106.889 36.3351C110.977 46.2023 112.046 57.0599 109.962 67.5349C107.879 78.0099 102.736 87.6317 95.1838 95.1838"
      stroke="currentColor"
      strokeWidth="6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
  <svg
    width="114"
    height="114"
    viewBox="0 0 114 114"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M57 3C68.8872 3 80.4423 6.92242 89.8731 14.1589C99.3039 21.3954 106.083 31.5416 109.16 43.0238C112.237 54.506 111.439 66.6825 106.889 77.6649C102.34 88.6473 94.2947 97.8217 84 103.765"
      stroke="currentColor"
      strokeWidth="6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
  <svg
    width="114"
    height="114"
    viewBox="0 0 114 114"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M57 3C70.1008 3 82.7549 7.76266 92.6047 16.4006C102.454 25.0386 108.828 36.9628 110.538 49.9516C112.248 62.9403 109.178 76.1078 101.899 87.0008C94.6209 97.8937 83.6307 105.769 70.9762 109.16"
      stroke="currentColor"
      strokeWidth="6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
  <svg
    width="114"
    height="114"
    viewBox="0 0 114 114"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M57 3C64.0914 3 71.1133 4.39675 77.6649 7.11051C84.2165 9.82426 90.1694 13.8019 95.1838 18.8162C100.198 23.8306 104.176 29.7835 106.889 36.3351C109.603 42.8867 111 49.9086 111 57C111 64.0914 109.603 71.1133 106.889 77.6649C104.176 84.2165 100.198 90.1694 95.1838 95.1838C90.1694 100.198 84.2165 104.176 77.6649 106.89C71.1133 109.603 64.0914 111 57 111"
      stroke="currentColor"
      strokeWidth="6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
  <svg
    width="114"
    height="114"
    viewBox="0 0 114 114"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M57 3C64.6866 3 72.2847 4.64102 79.2862 7.81335C86.2877 10.9857 92.5312 15.6162 97.5993 21.3953C102.667 27.1744 106.443 33.969 108.675 41.3246C110.906 48.6803 111.541 56.4275 110.538 64.0484C109.535 71.6693 106.916 78.9881 102.857 85.5157C98.7979 92.0432 93.392 97.6289 87.0008 101.899C80.6096 106.17 73.3803 109.027 65.7964 110.279C58.2124 111.531 50.4485 111.149 43.0238 109.16"
      stroke="currentColor"
      strokeWidth="6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
  <svg
    width="114"
    height="114"
    viewBox="0 0 114 114"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M57 3C65.2829 3 73.4549 4.90542 80.8836 8.56887C88.3123 12.2323 94.7988 17.5556 99.8411 24.1269C104.883 30.6982 108.346 38.3413 109.962 46.4651C111.578 54.5889 111.304 62.9755 109.16 70.9762C107.016 78.9769 103.061 86.3772 97.5993 92.6047C92.138 98.8321 85.3173 103.72 77.6649 106.889C70.0125 110.059 61.7334 111.426 53.4682 110.884C45.203 110.343 37.1732 107.907 30 103.765"
      stroke="currentColor"
      strokeWidth="6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
  <svg
    width="114"
    height="114"
    viewBox="0 0 114 114"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M57 3C65.8804 3 74.6237 5.19008 82.4554 9.37625C90.2872 13.5624 96.9657 19.6155 101.899 26.9992C106.833 34.3829 109.87 42.8695 110.74 51.7071C111.61 60.5447 110.288 69.4605 106.889 77.6649C103.491 85.8693 98.1218 93.1089 91.2572 98.7426C84.3926 104.376 76.2446 108.23 67.5349 109.962C58.8252 111.695 49.8226 111.253 41.3246 108.675C32.8267 106.097 25.0956 101.463 18.8162 95.1838"
      stroke="currentColor"
      strokeWidth="6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
  <svg
    width="114"
    height="114"
    viewBox="0 0 114 114"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M57 3C66.479 3 75.791 5.49514 84 10.2346C92.209 14.9741 99.0259 21.791 103.765 30C108.505 38.209 111 47.521 111 57C111 66.479 108.505 75.791 103.765 84C99.0259 92.209 92.209 99.0259 84 103.765C75.791 108.505 66.479 111 57 111C47.521 111 38.209 108.505 30 103.765C21.791 99.0259 14.9741 92.209 10.2346 84"
      stroke="currentColor"
      strokeWidth="6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
  <svg
    width="114"
    height="114"
    viewBox="0 0 114 114"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M57 3C67.0789 3 76.9566 5.82074 85.5157 11.1431C94.0747 16.4654 100.973 24.0769 105.431 33.1164C109.889 42.1559 111.728 52.2626 110.74 62.2929C109.752 72.3233 105.977 81.877 99.8411 89.8731C93.7054 97.8693 85.4544 103.989 76.0215 107.539C66.5886 111.089 56.3503 111.929 46.4651 109.962C36.5799 107.996 27.4422 103.303 20.086 96.4126C12.7298 89.5228 7.4486 80.7117 4.84 70.9762"
      stroke="currentColor"
      strokeWidth="6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M33 56.2002L38.5 61.6658"
      stroke="currentColor"
      strokeWidth="6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
  <svg
    width="114"
    height="114"
    viewBox="0 0 114 114"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M33 56.2002L38.5 61.6658L49.8689 73.0002"
      stroke="currentColor"
      strokeWidth="6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M57 3C67.6802 3 78.1205 6.16704 87.0008 12.1006C95.881 18.0342 102.802 26.4679 106.889 36.3351C110.977 46.2023 112.046 57.0599 109.962 67.5349C107.879 78.0099 102.736 87.6317 95.1838 95.1838C87.6317 102.736 78.0099 107.879 67.5349 109.962C57.0599 112.046 46.2023 110.977 36.3351 106.889C26.4679 102.802 18.0342 95.881 12.1006 87.0008C6.16704 78.1205 3 67.6802 3 57"
      stroke="currentColor"
      strokeWidth="6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
  <svg
    width="114"
    height="114"
    viewBox="0 0 114 114"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M33 56.2L38.5 61.6655L49.8689 73L61.2361 61.6655"
      stroke="currentColor"
      strokeWidth="6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M57 3C68.2829 3 79.2825 6.53421 88.4538 13.1063C97.6251 19.6783 104.507 28.9581 108.134 39.6423C111.761 50.3264 111.95 61.8783 108.675 72.6754C105.4 83.4725 98.8245 92.9724 89.8731 99.8411C80.9218 106.71 70.0438 110.602 58.7668 110.971C47.4899 111.34 36.3807 108.168 26.9992 101.899C17.6178 95.6309 10.4355 86.5813 6.46109 76.0215C2.48667 65.4618 1.91976 53.9223 4.84 43.0238"
      stroke="currentColor"
      strokeWidth="6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
  <svg
    width="114"
    height="114"
    viewBox="0 0 114 114"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M33 56.2L38.5 61.6656L49.8689 73L61.2361 61.6656L68.4344 54.5"
      stroke="currentColor"
      strokeWidth="6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M57 3C68.8872 3 80.4423 6.92242 89.8731 14.1589C99.3039 21.3954 106.083 31.5416 109.16 43.0238C112.237 54.506 111.439 66.6825 106.889 77.6649C102.34 88.6473 94.2947 97.8217 84 103.765C73.7053 109.709 61.7371 112.09 49.9516 110.538C38.166 108.986 27.2218 103.589 18.8162 95.1838C10.4107 86.7782 5.01358 75.834 3.46198 64.0484C1.91038 52.2629 4.291 40.2947 10.2346 30"
      stroke="currentColor"
      strokeWidth="6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
  <svg
    width="114"
    height="114"
    viewBox="0 0 114 114"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M33 56.2L38.5 61.6656L49.8689 73L61.2361 61.6656L68.4344 54.5L73.9672 49"
      stroke="currentColor"
      strokeWidth="6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M57 3C69.4932 3 81.5999 7.33184 91.2572 15.2574C100.915 23.183 107.525 34.212 109.962 46.4651C112.4 58.7183 110.513 71.4374 104.624 82.4554C98.7345 93.4734 89.2071 102.109 77.6649 106.889C66.1227 111.67 53.2798 112.301 41.3246 108.675C29.3694 105.048 19.0415 97.3885 12.1006 87.0008C5.15979 76.6131 2.03548 64.1401 3.26003 51.7071C4.48458 39.274 9.98223 27.6502 18.8162 18.8162"
      stroke="currentColor"
      strokeWidth="6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
  <svg
    width="114"
    height="114"
    viewBox="0 0 114 114"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M33 56.2L38.5 61.6656L49.8689 73L61.2361 61.6656L68.4344 54.5L73.9672 49L77.9836 45"
      stroke="currentColor"
      strokeWidth="6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M57 3C70.1008 3 82.7549 7.76266 92.6047 16.4006C102.454 25.0386 108.828 36.9628 110.538 49.9516C112.248 62.9403 109.178 76.1078 101.899 87.0008C94.6209 97.8937 83.6307 105.769 70.9762 109.16C58.3218 112.551 44.8662 111.225 33.1164 105.431C21.3666 99.6368 12.124 89.7685 7.11051 77.6649C2.09703 65.5613 1.65464 52.0479 5.86577 39.6423C10.0769 27.2367 18.6543 16.7851 30 10.2346"
      stroke="currentColor"
      strokeWidth="6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
  <svg
    width="114"
    height="114"
    viewBox="0 0 114 114"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M57 3C70.7103 3 83.9073 8.21507 93.914 17.5873C103.921 26.9596 109.988 39.7873 110.884 53.4682C111.781 67.1492 107.44 80.659 98.7426 91.2572C90.0448 101.855 77.6414 108.748 64.0484 110.538C50.4554 112.328 36.6906 108.88 25.5462 100.894C14.4018 92.9078 6.71234 80.9817 4.03759 67.5349C1.36285 54.088 3.90311 40.1272 11.1431 28.4843C18.3831 16.8415 29.7806 8.38849 43.0238 4.84"
      stroke="currentColor"
      strokeWidth="6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M33 56.2L49.8689 73L82 41"
      stroke="currentColor"
      strokeWidth="6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
  <svg
    width="114"
    height="114"
    viewBox="0 0 114 114"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M57 3C64.0914 3 71.1133 4.39675 77.6649 7.11051C84.2165 9.82426 90.1694 13.8019 95.1838 18.8162C100.198 23.8306 104.176 29.7835 106.889 36.3351C109.603 42.8867 111 49.9086 111 57C111 64.0914 109.603 71.1133 106.889 77.6649C104.176 84.2165 100.198 90.1694 95.1838 95.1838C90.1694 100.198 84.2165 104.176 77.6649 106.89C71.1133 109.603 64.0914 111 57 111C49.9086 111 42.8867 109.603 36.3351 106.889C29.7835 104.176 23.8306 100.198 18.8162 95.1838C13.8019 90.1694 9.82425 84.2165 7.1105 77.6649C4.39674 71.1133 3 64.0914 3 57C3 49.9086 4.39676 42.8866 7.11052 36.3351C9.82427 29.7835 13.8019 23.8306 18.8163 18.8162C23.8306 13.8019 29.7835 9.82424 36.3351 7.11049C42.8867 4.39674 49.9087 3 57 3L57 3Z"
      stroke="currentColor"
      strokeWidth="6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M33 56.2L49.8689 73L82 41"
      stroke="currentColor"
      strokeWidth="6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
];
